import Devices from "../components/Devices";
import MapCard from "../components/MapCard";
import Profile from "../components/Profile";
import { getDashboard } from "api/dashboard";
import { getDashboardDeviceCount, useAppDispatch } from "util/hooks";
import { setLoading } from "store/appSlice";
import { DashboardReqBody, Section } from "api/types/dashboard";
import { useEffect } from "react";
import { ModelFilterDropdown } from "models/dropdowns/modelFilter";
import { usePermissions } from "hooks/usePermissions";
import Generic from "../components/Generic";
import { shallowEqual, useSelector } from "react-redux";
import { getDashboardOverview } from "store/page/pageSelectors";
import { setDashboardOverview } from "store/page/pageSlice";
import { ROLES } from "models/constants/roles";

const OverviewDashboard = () => {
  const dispatch = useAppDispatch();
  const metrics = useSelector(getDashboardOverview, shallowEqual);
  const { canShow } = usePermissions();

  const getDashboardData = async () => {
    const sections: DashboardReqBody = {
      sections: [
        Section.USER_COUNT,
        Section.SITE_COUNT,
        Section.DEVICE_COUNT,
        Section.DEVICE_LOCATIONS,
        Section.DEVICE_MODEL_BREAKDOWN,
      ],
    };
    if (!metrics.data) dispatch(setLoading(true));
    const { data, isLoading, status } = await getDashboard(sections);
    dispatch(setLoading(isLoading));
    if (status === 200) {
      const counts = getDashboardDeviceCount(
        ModelFilterDropdown,
        data?.deviceModelBreakdown || []
      );

      dispatch(
        setDashboardOverview({
          ...metrics,
          data,
          counts,
        })
      );
    } else {
    }
  };

  useEffect(() => {
    getDashboardData();
  }, []);

  return (
    <div className={`mt-2`}>
      <div className={`flex h-full flex-col gap-2 `}>
        <div className="flex flex-col gap-2 py-1 lg:flex-row lg:overflow-x-auto">
          <div className="min-w-[350px] flex-1">
            <Profile />
          </div>
          {canShow(ROLES.ROLE_MANAGER) && (
            <div className="min-w-[280px] flex-1">
              <Generic
                count={metrics?.data?.userCount}
                color="100"
                textColor="white"
                context="users"
              />
            </div>
          )}
          <div className="min-w-[280px] flex-1">
            <Generic
              count={metrics?.data?.siteCount}
              color="200"
              textColor="white"
              context="sites"
            />
          </div>
        </div>
        <div className="flex flex-col gap-2 py-1 lg:flex-row lg:overflow-x-auto">
          <div className="min-w-[300px] flex-1">
            <Devices type="water" count={metrics?.counts?.water} />
          </div>
          <div className="min-w-[300px] flex-1">
            <Devices type="electricity" count={metrics?.counts?.electricity} />
          </div>
          <div className="min-w-[300px] flex-1">
            <Devices type="temperature" count={metrics?.counts?.temperature} />
          </div>
          <div className="min-w-[300px] flex-1">
            <Devices type="level" count={metrics?.counts?.level} />
          </div>
          <div className="min-w-[300px] flex-1">
            <Devices type="gas" count={metrics?.counts?.gas} />
          </div>
        </div>
        <div className={`grid grid-cols-1`}>
          <MapCard markers={metrics?.data?.deviceLocations} />
        </div>
      </div>
    </div>
  );
};

export default OverviewDashboard;
